<template>
  <!--로그인상태{{ $store.getters.isAuthenticated }}-->
  
  <form @submit.prevent="submitForm" :class="{mobile_write:isMobile}">
    <!--1:1 문의, 광고/제휴는 분리 -->
    
    <div v-if="document==='inquiry'">
      <base-title>1:1문의</base-title>      
    </div>
    <div v-if="document==='alliance'">
      <base-title>광고/제휴</base-title>
    </div>

    <div class="form-control" v-if="postDocuments">
        <label for="selectPostDocument" class="inp" :class="{ invalid: !selected.isValid }">
            <select v-model="selected.val">
                <template   v-for="(doc,index) in postDocuments.subs[0]">
                <option                  
                    :key="index"
                    :value="`${doc.name}`"
                    v-if="doc.name !== 'notice'"
                >
                    {{ doc.title }}
                </option>
                </template>
            </select>
            <span class="label">게시판 선택</span>
            <span class="focus-bg"></span>
        </label>
    </div>

    <div class="form-control">
      <label for="inp" class="inp" :class="{ invalid: !title.isValid }">
        <input
          type="text"
          id="title"
          v-model.trim="title.val"
          @blur="clearValidity('title')"
          placeholder="&nbsp;"
        />
        <span class="label">제목</span>
        <span class="focus-bg"></span>
      </label>
    </div>
    <div id="editor" @keypress="test" class="form-control"></div>
    <div>
        <div style="border:1px solid #ccc">
            <ckeditor :editor="editor" :config="editorConfig" @ready="onReady" v-model="editorData"></ckeditor>
        </div>
    <!-- <div class="form-control">
        <label for="selectPostDocument" class="inp">
            <input type="file" id="icon" @change="onFileChange" />
            <span class="label">이미지 첨부</span>
            <span class="focus-bg"></span>
        </label>
        <div id="preview">
            <img v-if="url" :src="url" width="200"/>
        </div>
    </div> -->
  
        <p v-if="!formIsValid">필수 항목을 입력하시고 다시 시도해 주세요!!</p>
        <div class="btn_part">
          <base-button>{{ButtonCaption}}</base-button>
        </div>
    </div>
  </form>
</template>

<script>
//import CKEditor from '@ckeditor/ckeditor5-vue';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import UploadAdapter from '@/utils/uploadAdapter';
export default {
    name:'postform',
    props:[
        'document','postdata','isMobile'
    ],
  data() {
    return {
        selected:{
            val:this.document,
            isValid:true
        },
        title: {
            val: this.postdata?this.$store.state.posts.viewpost.title:'',
            isValid: true,
        },
        content: {
            val: "",
            isValid: true,
        },
        formIsValid: true,
        postDocuments:{},
        image1: "",
        image2: "",
        url:null,
        imageUrl:"",
        editor:DecoupledEditor,
        editorData: this.postdata?this.$store.state.posts.viewpost.content:'',
        editorConfig: {
            // The configuration of the editor.
            extraPlugins: [this.uploader],
             link: {
                decorators: {
                    openInNewTab: {
                        mode: 'manual',
                        label: '새로운창에 띄우기',
                        attributes: {
                            target: '_blank',
                            rel: 'noopener noreferrer'
                        }
                    }
                }
            }
        }
    };
  },
//   components: {
//     ckeditor: CKEditor.component
//    },
mounted(){
  if(this.postdata)
  {
    this.selected.val = this.$store.state.posts.viewpost.document.name      
  }
},
  computed:{
    ButtonCaption() {
      if (this.postdata) {
        return "수정하기";
      } else {
        return "등록하기";
      }
    },
  },
  created(){
      //메뉴에서 게시판 종류 가져온다
      const ActiveMenu = this.$store.state.menu.activeMenu;
      this.postDocuments = this.$store.getters['menu/getMenu'].find((menu) => menu.name === ActiveMenu);
      console.log('게시판 폼에서',this.postDocuments);
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.image1 =file;
      let reader = new FileReader();
      reader.readAsDataURL( file );

      reader.onload = () => {
            this.imageUrl = reader.result;
      };
      this.url = URL.createObjectURL(file);
    },
    onReady( editor )  {
        // Insert the toolbar before the editable area.
        editor.ui.getEditableElement().parentElement.insertBefore(
            editor.ui.view.toolbar.element,
            editor.ui.getEditableElement()
        );
    },
    read() {

    },
    clearValidity(input) {
      this[input].isValid = true;
    },
    clear() {
      this.title.val = "";
      this.selected.val = "";
      this.editorData = "";

    },
    validateForm() {
      this.formIsValid = true;
      if (this.selected.val === "" || this.selected.val === "all") {
        this.selected.isValid = false;
        this.formIsValid = false;
      }
      if (this.title.val === "") {
        this.title.isValid = false;
        this.formIsValid = false;
      }
      if (this.editorData === "") {
        this.formIsValid = false;
      }

    },
    submitForm() {
      this.validateForm();

      if (!this.formIsValid) {
        return;
      }

      let formData = new FormData();
      formData.append("document_name", this.selected.val);
      
      formData.append("user_id", this.$store.getters.currentUser.id);
      formData.append("title", this.title.val);
      formData.append("content", this.editorData);
      formData.append('image1',this.image1);
      
      formData.append('post_id',this.postdata?this.$store.state.posts.viewpost.id:0);
      let edit = this.postdata?true:false;
      this.$emit("save-data", {formData:formData, edit:edit});
      this.clear();
    },

    uploader(editor)
    {
        editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
            return new UploadAdapter( loader );
        };
    },
  },
};
</script>
<style lang="scss" scoped>

@import "@/assets/scss/form";
.btn_part{
  display:flex;
  justify-content: center;
  margin-top:10px;
}
</style>
<style lang="scss" >
@import "@/assets/scss/form";
.ck-editor__editable_inline {
    min-height: 400px;
}
</style>
